import { Box, Text, Heading } from '@redriverpress/system'
import { Link } from '../../common/components/typography'
import sidebarItems from '../data/sidebar-item'

function Badge({ type, ...props }) {
  const { name, ...typeProps } = type

  return (
    <Box
      borderRadius='rounded'
      py={2}
      px={3}
      display='inline-block'
      {...typeProps}
      {...props}
    >
      <Text
        fontSize='0.75rem'
        fontWeight={600}
        letterSpacing='wide'
        style={{ textTransform: 'uppercase' }}
      >
        {name}
      </Text>
    </Box>
  )
}

function SidebarItem({ item, ...props }) {
  return (
    <Box {...props}>
      <Box>
        <Badge type={item.type} mb={3} />
      </Box>
      <Heading as='h5' mb={3}>
        {item.title}
      </Heading>
      <Text mb={2}>{item.description}</Text>
      <Link href={item.link}>Learn more</Link>
    </Box>
  )
}

export default function Sidebar(props) {
  return (
    <Box {...props}>
      {sidebarItems.map((item, idx) => (
        // eslint-disable-next-line react/no-array-index-key
        <SidebarItem key={idx} item={item} pb={[4, null, null, null, 5]} />
      ))}
    </Box>
  )
}
